<template>
  <li class="report_section_li">
    <div class="section_wrap report_preview_wrap">
      <h6 class="--blue70 mb10">
        {{ $t( 'report.report' ) }}
      </h6>
      <div class="right_btn_container"> <!--출력버튼 -->
        <div class="right_edit_btn pointer right_btn">
          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" @click="open=!open" v-tooltip="this.$t('status.preview_print')"
               width="23" height="23"
               viewBox="0 0 172 172"
               style=" fill:#000000;">
            <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter"
               stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none"
               font-size="none" text-anchor="none" style="mix-blend-mode: normal">
              <path d="M0,172v-172h172v172z" fill="none"></path>
              <g fill="#275cbb">
                <path
                        d="M46.10096,0c-10.87921,0 -19.84615,8.96695 -19.84615,19.84615v33.07692h-6.40865c-10.95673,0 -19.84615,8.88942 -19.84615,19.84615v39.69231c0,10.95673 8.88942,19.84615 19.84615,19.84615h6.40865v19.84615c0,10.87921 8.96695,19.84615 19.84615,19.84615h79.38462c10.87921,0 19.84615,-8.96695 19.84615,-19.84615v-19.84615h6.82212c10.95673,0 19.84615,-8.88942 19.84615,-19.84615v-39.69231c0,-10.95673 -8.88942,-19.84615 -19.84615,-19.84615h-6.82212v-33.07692c0,-10.87921 -8.96695,-19.84615 -19.84615,-19.84615zM46.10096,13.23077h79.38462c3.72115,0 6.61538,2.89423 6.61538,6.61538v33.07692h-92.61538v-33.07692c0,-3.72115 2.89423,-6.61538 6.61538,-6.61538zM142.23077,66.15385c5.47837,0 9.92308,4.44471 9.92308,9.92308c0,5.47837 -4.44471,9.92308 -9.92308,9.92308c-5.47837,0 -9.92308,-4.44471 -9.92308,-9.92308c0,-5.47837 4.44471,-9.92308 9.92308,-9.92308zM39.48558,99.23077h92.61538v52.92308c0,3.72115 -2.89423,6.61538 -6.61538,6.61538h-79.38462c-3.72115,0 -6.61538,-2.89423 -6.61538,-6.61538zM52.92308,112.46154v13.23077h66.15385v-13.23077zM52.92308,132.30769v13.23077h46.30769v-13.23077z"></path>
              </g>
            </g>
          </svg>
        </div>
      </div>
      <div class="basic_item"> <!-- 고정 컨테이너 -->
        <p class="report-item-title">{{$t('report.components.basic_information.name')}}</p>
        <span class="basic-item-description">
                    {{$t('report.components.basic_information.context')}}</span>
      </div>
      <div style="padding: 150px 0px;"
           :class="reportPreviewItems.length === 0 ? '': 'hidden'">
				{{$t('report.preview.info.select_at_least_one_item')}}
      </div>
      <ul class="report_item_container"
          :class="reportPreviewItems.length === 0 ? 'hidden': ''">
        <Draggable :list="reportPreviewItems" class="dragArea" v-bind="getDraggableOption()" @end="selectedItemIndex">
          <li v-for=" ({value},index) in reportPreviewItems" v-bind:key="value"
              :class="selectedIdx === index? 'row_select' : ''" class="handle" @click="selectedItemIndex(index, value)">
            <p class="report-item-title">
              <span class="pointer">{{ getPreviewItemLabel(value) }}</span>
            </p>
            <div class="right_report_btn_container">
              <div class="right_delete_btn pointer right_btn" @click="deletePreviewItem(value, index)">
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" v-tooltip="deleteTrans"
                     width="23" height="23"
                     viewBox="0 0 172 172"
                     style=" fill:#000000;">
                  <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1"
                     stroke-linecap="butt"
                     stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray=""
                     stroke-dashoffset="0"
                     font-family="none" font-weight="none" font-size="none" text-anchor="none"
                     style="mix-blend-mode: normal">
                    <path d="M0,172v-172h172v172z" fill="none"></path>
                    <g fill="#275cbb">
                      <path
                              d="M71.66667,14.33333l-7.16667,7.16667h-35.83333v14.33333h7.16667v107.5c0,7.83362 6.49972,14.33333 14.33333,14.33333h57.33333v-14.33333h-57.33333v-107.5h71.66667v71.66667h14.33333v-71.66667h7.16667v-14.33333h-7.16667h-28.66667l-7.16667,-7.16667zM64.5,50.16667v78.83333h14.33333v-78.83333zM93.16667,50.16667v78.83333h14.33333v-78.83333zM128.13216,121.32943l-10.13411,10.13411l15.20117,15.20117l-15.20117,15.20117l10.13411,10.13411l15.20117,-15.20117l15.20117,15.20117l10.13411,-10.13411l-15.20117,-15.20117l15.20117,-15.20117l-10.13411,-10.13411l-15.20117,15.20117z"></path>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
          </li>
        </Draggable>
      </ul>
    </div>
    <div class="bottom_area_left">
      <a class="btn blue btn_basics pointer no-drag" @click="this.openReportPreviewItemSelectModal">{{$t('report.preview.add_btn')}}</a>
    </div>
    <ReportPreviewItemSelectModal @updatePreviewItems="updatePreviewItems"></ReportPreviewItemSelectModal>
    <ReportModal :patientInfoProps="patientInfoProps" :reportPreviewItemsProps="reportPreviewItems" :open="open" @closeReport="closeReport"/>
  </li>
</template>
<script>
    import {REPORT_SECTION_ITEM} from "@/enum/lib";
    import {_REPORT_PREVIEW_ITEMS} from "../static"
    import {mapActions} from "vuex";
    import ReportModal from '@/components/modal/reportModal';
    import ReportPreviewItemSelectModal from '@/components/modal/reportPreviewItemSelectModal';

    export default {
        name: '',
        components: {
          ReportModal,
          ReportPreviewItemSelectModal
        },
        props : [ 'patientInfoProps', 'selectCompNo'],
        data() {
            const deleteTrans = this.$t('status.delete');
            return {
                open: false,
                selectedIdx : -1,
                reportPreviewItems : [],
                deleteTrans: deleteTrans
            }
        },
        methods: {
            ...mapActions(['updateExpertOpinionData', 'resetRomChartDataToVuex', 'updateChiefComplainData']),
            deletePreviewItem( value, index ) {
                if ( Number(value) === Number(this.selectCompNo) ) {
                    this.$emit('updateCompNo',Number(-1));
								}
                this.reportPreviewItems.removeIdxIfExist(index);

                switch (value) {
                  case REPORT_SECTION_ITEM.ROM_MONITORING : {
                    this.resetRomChartDataToVuex();
                    break;
                  }
                  case REPORT_SECTION_ITEM.CHIEF_COMPLAIN : {
                    this.updateChiefComplainData('');
                    break;
                  }
                  case REPORT_SECTION_ITEM.EXPERT_OPINION : {
                    this.updateExpertOpinionData('');
                    break;
                  }
                }
                event.stopPropagation();
            },
            selectedItemIndex(index, value ) {
              let newIndex = undefined;
              let newValue = undefined;

              if (value !== undefined) {
                newIndex = index;
                newValue = value;
              } else {
                try {
                  newIndex = index?.newIndex;
                  newValue = this.reportPreviewItems?.find((item) => {
                    return index?.item?.outerText?.replace(/(\r\n\t|\n|\r\t)/gm,"") === this.getPreviewItemLabel(item?.value)
                  })?.value;
                } catch (e) {
                  newIndex = undefined;
                  newValue = undefined;
                }
              }

              if (newIndex !== undefined && newValue !== undefined) {
                this.selectedIdx = newIndex;
                this.$emit('updateCompNo', newValue);
              }
            },
            openReportPreviewItemSelectModal() {
                this.$modal.show('report-preview-items-select-modal', {
                    reportPreviewItems : this.reportPreviewItems } );
            },
            updatePreviewItems( items ) {
              this.reportPreviewItems.clear();

              let i;
              for (i = 0; i < items.length; i++)
                this.$set(this.reportPreviewItems, i, items[i]);

              this.selectedItemIndex(--i, items[i].value)
            },
            getPreviewItemLabel( value ) {
                return this.$t(_REPORT_PREVIEW_ITEMS[value].trans);
            },
            closeReport() {
                this.open = false;
						},
            getDraggableOption() {
                return {
                  animation: 300,
                  handle: '.handle',
                  delay: 100,
                  delayOnTouchOnly: true,
                }
						}
        },
        watch: {
          patientInfoProps: {
            deep: true,
            handler( newVal, oldVal ) {
              if ( newVal.seqPatient !== oldVal.seqPatient ) {
                this.reportPreviewItems.clear();
                this.$emit('updateCompNo',Number(-1));
              }
            }
          }
      }
    }
</script>
<style lang="scss">
  .report_preview_wrap {
    .right_btn_container {
      margin-top: -40px;
    }

    .basic_item {
      background: #ebebeb;
      border-radius: 10px;
      margin-top: 25px;
      text-align: left;
      padding: 15px;

      .basic-item-description {
        font-size: 12px;
        color: #a1a1a1;
      }
    }

    .report-item-title {
      font-size: 16px;
      font-weight: 700;
      line-height: 1.5;
    }

    .report_item_container {
      text-align: left;
      margin-bottom: 50px;
      margin-top: 7px;

      li {
        background: #f7f7f7;
        border-radius: 10px;
        margin-top: 7px;
        padding: 15px;
        display: grid;
        grid-template-columns: 10fr 1fr;

        .right_report_btn_container {
          display: flex;

          .right_btn {
            margin-left: 7px;
          }
        }

        &.row_select {
          background: #f7fbff;
          border: 1px solid var(--blue70);
          border-radius: 10px;
        }
      }
    }

  }
</style>